import { ReactComponent as BrowserIcon } from '../assets/img/svg/browser.svg'
import { ReactComponent as CalendarIcon } from '../assets/img/svg/calendar.svg'
import { ReactComponent as CheckIcon } from '../assets/img/svg/check.svg'
import { ReactComponent as ClockOneIcon } from '../assets/img/svg/clock-one.svg'
import { ReactComponent as ClockTwoIcon } from '../assets/img/svg/clock-two.svg'
import { ReactComponent as DocumentIcon } from '../assets/img/svg/document.svg'
import { ReactComponent as HashtagIcon } from '../assets/img/svg/hashtag.svg'
import { ReactComponent as InfinityIcon } from '../assets/img/svg/infinity.svg'
import { ReactComponent as LocationPinIcon } from '../assets/img/svg/location-pin.svg'
import { ReactComponent as MultipleCheckIcon } from '../assets/img/svg/multiple-check.svg'
import { ReactComponent as PhoneIcon } from '../assets/img/svg/phone.svg'
import { ReactComponent as PictureIcon } from '../assets/img/svg/picture.svg'
import { ReactComponent as PictureTwoIcon } from '../assets/img/svg/picture-two.svg'
import { ReactComponent as PinIcon } from '../assets/img/svg/pin.svg'
import { ReactComponent as QuestionIcon } from '../assets/img/svg/question.svg'
import { ReactComponent as SlidesIcon } from '../assets/img/svg/slides.svg'
import { ReactComponent as StarIcon } from '../assets/img/svg/star.svg'
import { ReactComponent as TagIcon } from '../assets/img/svg/tag.svg'
import { ReactComponent as TextInputIcon } from '../assets/img/svg/text-input.svg'

export const HIGH_IMPACT = 3
export const MEDIUM_IMPACT = 2
export const LOW_IMPACT = 1

export const checklistMetrics = [
  {
    id: 'website',
    name: 'Website',
    description: 'The location has a URL linked to it.',
    icon: BrowserIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
  {
    id: 'logo',
    name: 'Logo',
    description: 'The location has a logo.',
    icon: InfinityIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/images',
  },
  {
    id: 'cover',
    name: 'Cover Image',
    description: 'The location has a cover image.',
    icon: PictureTwoIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/images',
  },
  {
    id: 'lastPost',
    name: 'Last post date',
    description: 'The location has a post in the last 7 days.',
    icon: CalendarIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/posts/cta',
  },
  {
    id: 'reviewAverage',
    name: 'Review Average',
    description: 'The location has a review average of 4 or higher.',
    icon: StarIcon,
    impact: HIGH_IMPACT,
    canEdit: false,
  },
  {
    id: 'specialHours',
    name: 'Special Hours',
    description: 'The location has special hours set for the next holidays.',
    icon: ClockOneIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
  {
    id: 'services',
    name: 'Services',
    description:
      'The location has a description of the services offered by it.',
    icon: SlidesIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
  {
    id: 'regularHours',
    name: 'Regular Hours',
    description: 'The location has the regular hours set and up to date.',
    icon: ClockOneIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
  {
    id: 'businessName',
    name: 'Business Name',
    description: 'The location name is the brand name.',
    icon: TextInputIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
  {
    id: 'phoneNumber',
    name: 'Phone Number',
    description: 'The location has a phone number.',
    icon: PhoneIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
  {
    id: 'category',
    name: 'Category',
    description: 'The location has at most 5 categories to be described by.',
    icon: TagIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
  {
    id: 'description',
    name: 'Description',
    description:
      'The location has a description with more than 400 characters.',
    icon: DocumentIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
  {
    id: 'address',
    name: 'Location address',
    description: 'The location has a physical address linked to it.',
    icon: LocationPinIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
  {
    id: 'pendingUpdates',
    name: 'Pending updates',
    description: 'The location has no pending information or Google edits.',
    icon: CheckIcon,
    impact: HIGH_IMPACT,
    canEdit: true,
    editUrl: '/locations/pending',
  },
  {
    id: 'pendingReviews',
    name: 'Reviews with answers',
    description: 'The location has no pending reviews to answer.',
    nullReason: 'This location has no reviews.',
    icon: ClockTwoIcon,
    impact: MEDIUM_IMPACT,
    canEdit: true,
    editUrl: '/reviews',
  },
  {
    id: 'pendingQuestions',
    name: 'Questions with answers',
    description: 'The location has no pending questions to answer.',
    nullReason: 'This location has no questions.',
    icon: QuestionIcon,
    impact: MEDIUM_IMPACT,
    canEdit: true,
    editUrl: '/locations/questions',
  },
  {
    id: 'attributes',
    name: 'Location Attributes',
    description: 'The location has at least 5 attributes to be described by.',
    icon: MultipleCheckIcon,
    impact: MEDIUM_IMPACT,
    canEdit: false,
  },
  {
    id: 'urlParameters',
    name: 'URL with parameters',
    description: 'The location URL has tracking parameters.',
    icon: HashtagIcon,
    impact: LOW_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
  {
    id: 'media',
    name: 'Location Media',
    description: 'The location owner has uploaded media about the location.',
    icon: PictureIcon,
    impact: LOW_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/images',
  },
  {
    id: 'openingDate',
    name: 'Opening Date',
    description: 'The location has the date on which it first opened.',
    icon: PinIcon,
    impact: LOW_IMPACT,
    canEdit: true,
    editUrl: '/locations/edit/general',
  },
]
